import { gql } from "@apollo/client";

export default gql`
  query getReportTypes {
    getReportTypes {
      id
      name
    }
  }
`;
